// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"996":"7e38bffa9ea2e4cd","997":"df288f8467ec0446"}[chunkId] + ".js";
};